<template>
    <div class="content-card mb-4">
        <div class="content-card-title d-flex justify-content-start flex-wrap gap-2">
            จำนวนค่าคอมต่อวัน
            <!-- <button class="btn btn-outline-primary btn-filter btn-active"><i
                    class="fa-icon fa-solid fa-circle-check me-2"></i>จำนวนค่าคอมต่อวัน</button>
            <button class="btn btn-outline-secondary btn-filter"><i
                    class="fa-icon fa-solid fa-circle me-2"></i>จำนวนเพื่อนที่เราแนะนำต่อวัน</button> -->
        </div>
        <div class="content-card-body">
            <div class="table-responsive">
              <table class="table table-sm table-hover table-bordered table-vcenter">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th scope="col" style="width: 40%;">ประเภทเกม (ส่วนแบ่ง %)</th>
                    <th scope="col" style="width: 30%;">ยอดแทงสมาชิก</th>
                    <th scope="col" style="width: 30%;">รายได้</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="gamesAffiliateData.af_credit_to_credit_stagement">
                  <tr v-for="(item, index) in gamesAffiliateData.af_credit_to_credit_stagement" :key="index">
                    <td>หวยออนไลน์ ({{ item.af_share }}%)</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(item.price ? item.price : 0).toFixed(2)) }}</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(item.af_credit_request_to_move ? item.af_credit_request_to_move : 0).toFixed(2)) }}</td>
                  </tr>
                  </template>
                  <template v-else>
                  <tr>
                  <td>หวยออนไลน์ ({{ gamesAffiliateData.market_share_casino}}%)</td>
                  <td class="text-end">0.00</td>
                  <td class="text-end">0.00</td>
                  </tr>
                  </template>
                  <tr>
                    <td>คาสิโนออนไลน์ ({{ gamesAffiliateData.marketing_share_casino }}%)</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(gamesAffiliateData.afCasinoTypeCasinoBet ? gamesAffiliateData.afCasinoTypeCasinoBet : 0).toFixed(2)) }}</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(gamesAffiliateData.afCasinoTypeCasino ? gamesAffiliateData.afCasinoTypeCasino : 0).toFixed(2)) }}</td>
                  </tr>
                  <tr>
                    <td>สล็อตเกม ({{ gamesAffiliateData.marketing_share_slot }}%)</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(gamesAffiliateData.afCasinoTypeSlotBet ? gamesAffiliateData.afCasinoTypeSlotBet : 0).toFixed(2)) }}</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(gamesAffiliateData.afCasinoTypeSlot ? gamesAffiliateData.afCasinoTypeSlot : 0).toFixed(2)) }}</td>
                  </tr>
                  <tr>
                    <td>บอล/กีฬา ออนไลน์ ({{ gamesAffiliateData.marketing_share_sport }}%)</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(gamesAffiliateData.afCasinoTypeSportBet ? gamesAffiliateData.afCasinoTypeSportBet : 0).toFixed(2)) }}</td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(gamesAffiliateData.afCasinoTypeSport ? gamesAffiliateData.afCasinoTypeSport : 0).toFixed(2)) }}</td>
                  </tr>
                  <tr>
                    <td colspan="2"><b>ยอดรวม</b></td>
                    <td class="text-end">{{ numberWithCommas(parseFloat(gamesAffiliateData.sumProfit ? gamesAffiliateData.sumProfit : 0).toFixed(2)) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  async mounted () {
    if (process.env.VUE_APP_CASINO_ENABLE.toLowerCase().trim() === 'false') {
      this.$router.push('/member')
    }
    try {
      const today = new Date()
      this.date_from = (today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate())
      this.date_to = (today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate())
      await this.getAffiliate()
    } catch (error) {
    }
  },
  computed: {
    ...mapGetters([
      'getGames'
    ])
  },
  methods: {
    ...mapActions(['getGamesAffiliate']),
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async getAffiliate () {
      const resp = await this.getGamesAffiliate({
        date: {
          from: this.date_from,
          to: this.date_to
        }
      })
      // const today = new Date()
      // console.log('resp.status_code:' + resp.KINGMAKER)
      this.gamesAffiliateData = resp
      // console.log('resp:' + resp)
      // console.log('today:' + (today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()))
    }
  },
  data () {
    return {
      date_from: '',
      date_to: '',
      gamesAffiliateData: []
    }
  }
}
</script>
